import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { ParamsType, Taxonomies, PageParams } from '@app/constants';
import { DataService } from '@app/data';

@Component({
  selector: 'app-back-btn',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './back-btn.component.html',
  styleUrls: ['./back-btn.component.less']
})
export class BackBtnComponent implements OnInit, OnDestroy {

  @Input() currentTaxonomyPage$!: Observable<Taxonomies>;
  @Input() route$!: Observable<any>;
  @Input() showIcon: boolean = true;

  private unsubscribe$: Subject<void> = new Subject();

  constructor(

    private data: DataService
  ) {}

  ngOnInit(): void {
    //console.log('BackBtnComponent this.route ', this.route);
    /*this.currentTaxonomyPage$.pipe(
      filter(data => data !== undefined),
      takeUntil(this.unsubscribe$)
    ).subscribe(data => console.log('BackBtnComponent subscribe data ', data));*/
  }

  ngOnDestroy(): void {
    //console.log('SearchComponent ngOnDestroy');

    this.unsubscribe$.next();
    this.unsubscribe$.complete();    
  }

  public getRoute = (route: any): any => {
    //console.log('BackBtnComponent getRoute route ', route);

    return !route ? false : route.backBtn ? route.backBtn : route;
  };

  public clearParams = (params: ParamsType): ParamsType => this.data.clearParentQueryParams(params, true);

}
